import {
	Box,
	Typography,
	Paper, List, ListSubheader, ToggleButtonGroup, ToggleButton
} from "@mui/material";
import {useTranslation} from "react-i18next";
import {gql, useQuery} from "@apollo/client";
import {useRouter} from "next/router";
import {useKeycloak} from "src/useKeycloak";
import CardElement from "components/CardElement";
import React, {useEffect, useState} from "react";
import {styled} from "@mui/material/styles";
import ActivityListItem from "../ActivityListItem";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
	faClipboardCheck,
	faPhonePlus,
	faTasks, faClockRotateLeft, faMushroom, faLoader
} from "@fortawesome/pro-solid-svg-icons";
import {ListWrapper} from "../../styles/ListComponents";
import {
	GetQueueItemsActivityDocument,
	useCountTasksQuery,
	useGetQueueItemsActivityQuery
} from "../../generated/graphql";
import dayjs from "dayjs";
// import {useCountConversationsQuery} from '../../generated/graphql';

const PaperElement = styled(Paper)(
	({ theme }) => `
	height: calc(100% - ${theme.spacing(1)});
	width: 100%;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	overflow: hidden;
`
);

const Activities = (
	{
		data,
		loading,
		fetchingMore,
		error,
		route,
		navigation,
		filter,
		setFilter,
		setResponsibilityFilter,
		setTypeFilter,
		setDirectionFilter,
		assignedCount,
		otherCount,
		delegatedCount,
		conversationsCount,
		conversationsIncomingCount,
		conversationsOutgoingCount,
		conversationsUnansweredCount,
		loadingAssignedCount,
		loadingDelegatedCount,
		loadingOtherCount,
		privateList,
		setTerm,
		fetchMore,
		mainState,
		setMainState,
		headerTabClick
	}
) => {
	const { t } = useTranslation();
	const {tokenParsed} = useKeycloak();
	const router = useRouter();
	const scrollRef = React.useRef(null);
	const [secondaryMenuSelectedValue, setSecondaryMenuSelectedValue] = useState("OPEN");
	const [tabIndex, setTabIndex] = useState(0);
	const [items, setItems] = useState([]);
	const [selectedIndex, setSelectedIndex] = useState(0);
	const [placeholderText, setPlaceholderText] = useState(t("Tasks"));

	useEffect(() => {
		setSelectedIndex(0);
	}, []);

	const SubTabs = React.useMemo(() => {
		const items =
			tabIndex === 0 || tabIndex === 1
				? [
					{
						text: t("All tasks tab", { count: 0 }),
						placeholderText: t("Tasks"),
						typeValue: ["AGREED", "OTHER"],
						directionValue: ["INCOMING", "OUTGOING", "UNANSWERED"], //Mappet mot tab 1, for switch. Kan vurdere å hoppe til 'ALL' ved tabskifte
						responsibilityValue: ["MINE", "DELEGATED"]
					},
					{
						text:
							assignedCount > 0 && tabIndex === 0
								? t("Assigned tasks tab", { count: assignedCount ?? 0 })
								: t("Assigned tasks tab empty"),
						placeholderText: t("Assigned tasks tab empty"),
						typeValue: ["AGREED"],
						directionValue: ["INCOMING"],
						responsibilityValue: ["MINE"]
					},
					{
						text:
							otherCount > 0 && tabIndex === 0
								? t("Normal tasks tab", { count: otherCount ?? 0 })
								: t("Normal tasks tab empty"),
						placeholderText: t("Normal tasks tab empty"),
						typeValue: ["OTHER"],
						directionValue: ["OUTGOING"],
						responsibilityValue: ["MINE"]
					},
					{
						text:
							delegatedCount > 0 && tabIndex === 0
								? t("Delegated tab", { count: delegatedCount ?? 0 })
								: t("Delegated tab empty"),
						typeValue: ["AGREED", "OTHER"],
						placeholderText: t("Delegated tasks"),
						directionValue: ["UNANSWERED"],
						responsibilityValue: ["DELEGATED"]
					}
				]
				: [
					{
						text: t("All conversations tab empty"),
						placeholderText: t("All conversations tab empty"),
						typeValue: ["CONVERSATIONS"],
						directionValue: ["INCOMING", "OUTGOING", "UNANSWERED"],
						responsibilityValue: ["MINE"]
					},
					{
						text: t("Incoming calls tab empty"),
						placeholderText: t("Incoming calls tab empty"),
						typeValue: ["CONVERSATIONS"],
						directionValue: ["INCOMING"],
						responsibilityValue: ["MINE"]
					},
					{
						text: t("Outgoing calls tab empty"),
						placeholderText: t("Outgoing calls tab empty"),
						typeValue: ["CONVERSATIONS"],
						directionValue: ["OUTGOING"],
						responsibilityValue: ["MINE"]
					},
					{
						text: t("Unanswered calls tab empty"),
						placeholderText: t("Unanswered calls tab empty"),
						typeValue: ["CONVERSATIONS"],
						directionValue: ["UNANSWERED"],
						responsibilityValue: ["MINE"]
					}
				];

		setItems(items);
		setTypeFilter(items.at(selectedIndex).typeValue);
		setResponsibilityFilter(items.at(selectedIndex).responsibilityValue);
		setDirectionFilter(items.at(selectedIndex).directionValue);
		setSelectedIndex(selectedIndex);

		const handleSelect = (index) => {
			setTypeFilter(items.at(index).typeValue);
			setResponsibilityFilter(items.at(index).responsibilityValue);
			setDirectionFilter(items.at(index).directionValue);
			setPlaceholderText(items.at(index).placeholderText);
			console.log("setting selected index to ", index);
			setSelectedIndex(index);
		};

		return (
			<Box>
				<ToggleButtonGroup
					value={selectedIndex}
					exclusive
				>
					{items.map((item, index) => (
						<ToggleButton
							key={index}
							value={index}
							onClick={() => {
								handleSelect(index);
								setTabIndex(index);
								setFilter(item.text === t("All tasks tab", { count: 0 }) ? [] : filter);
							}}
							sx={{
								textTransform: "none",
								fontSize: "10px",
								color: "#151c42",
								height: "28px",
								width: "100px",
								"&.Mui-selected": {
									backgroundColor: "#daebff",
									color: "#151c42",
									"&:hover": {
										backgroundColor: "#daebff",
										color: "#151c42"
									}
								},
								"&:hover": {
									backgroundColor: "#daebff",
									color: "#151c42"
								}
							}}>
							{item.text}
						</ToggleButton>
					))}
				</ToggleButtonGroup>
			</Box>
		);
	}, [
		tabIndex,
		setTabIndex,
		filter,
		setTypeFilter,
		setResponsibilityFilter,
		setDirectionFilter,
		assignedCount,
		otherCount,
		selectedIndex,
		delegatedCount,
		loadingAssignedCount,
		loadingOtherCount,
		loadingDelegatedCount,
		route
	]);

	return (
		<Box sx={{height: "100%"}} >
			<PaperElement elevation={2} >
				{/*{queueItems?.length}*/}
				<CardElement
					title={t("Activities")}
					menuItems={[
						{
							icon: faTasks,
							primaryText: "Create task",
							secondaryText: "Make a task to yourself or a colleague",
							function: () => {
								const rata = {
									pathname: "/task",
									query: {
										type: "TASK"
									}
								};
								router.push(rata);
							}
						},
						{
							icon: faPhonePlus,
							primaryText: "Remember to call",
							secondaryText: "Set a reminder to call back",
							function: () => {
								const rata = {
									pathname: "/task",
									query: {
										type: "CALLBACK"
									}
								};
								router.push(rata);
							}
						}
					]}
					secondaryMenu={{
						value: secondaryMenuSelectedValue,
						onChange: (e, v) => {
							setSecondaryMenuSelectedValue(e.target.value);
							console.log("Secondary menu onChange function: " + e.target.value);
						},
						items: [
							{
								label: t("Open Tasks"),
								icon: faMushroom,
								value: "OPEN",
								onClick: (e) => {
									// setFilter(["ASSIGNED", "INPROGRESS", "PAUSED"]);
									// setTypeFilter(["AGREED", "OTHER"]);
									// setResponsibilityFilter(["MINE", "DELEGATED"]);
									// setDirectionFilter([]);
									headerTabClick(
										0,
										["ASSIGNED", "INPROGRESS", "PAUSED"],
										["AGREED", "OTHER"],
										["MINE", "DELEGATED"],
										[]
									);
									//setTabIndex(ix);
									//setSelectedIndex(0);
								}
							},
							{
								label: t("Done Tasks"),
								icon: faMushroom,
								value: "DONE",
								onClick: (e) => {
									// setFilter(["UNASSIGNED", "DONE", "LOGGED"]);
									// setTypeFilter(["AGREED", "OTHER"]);
									// setResponsibilityFilter(["MINE", "DELEGATED"]);
									// setDirectionFilter([]);
									headerTabClick(
										1,
										["UNASSIGNED", "DONE", "LOGGED"],
										["AGREED", "OTHER"],
										["MINE", "DELEGATED"],
										[]
									);
									// setTabIndex(ix);
									// setSelectedIndex(0);
								}
								// sx: {fontSize: 9}
							},
							{
								label: t("Call log"),
								icon: faMushroom,
								value: "CALL_LOG",
								onClick: (e) => {
									// setFilter(["UNASSIGNED", "DONE", "LOGGED"]);
									// setTypeFilter(["CONVERSATIONS"]);
									// setResponsibilityFilter(["MINE"]);
									// setDirectionFilter(["INCOMING", "OUTGOING", "UNANSWERED"]);
									headerTabClick(
										2,
										["UNASSIGNED", "DONE", "LOGGED"],
										["CONVERSATIONS"],
										["MINE"],
										["INCOMING", "OUTGOING", "UNANSWERED"]
									);
									// setTabIndex(ix);
									// setSelectedIndex(0);
								}
							}
						]
					}}
					//subHeader={SubTabs}
				>
					{/*{queueItems?.length > 0 && (*/}
					<List
						disablePadding
						ref={scrollRef}
						component="nav"
						style={{
							maxHeight: "100%",
							overflowY: "auto"
						}}
					>
						{loading &&
							<Box
								sx={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									height: "50px"
								}}
							>
								<FontAwesomeIcon icon={faLoader} size={"2xl"} spin={true} />
							</Box>
						}
						{
							data?.queueItems?.map((queueItem, idx) => (
								<ActivityListItem key={queueItem.id} queueItem={queueItem} idx={idx} fetchMoreQueueItems={() => {
									console.log("****  Fetching more queue items  ****");
									fetchMore({
										skip: loading,
										variables: {
											offset: data?.queueItems?.length
										}
									});
								}}/>
							))}
					</List>
					{/*)}*/}
				</CardElement>
			</PaperElement>
		</Box>
	);
};

export default Activities;
